<template>
  <div class="form-group form-group--help-block">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <span class="help-block" v-if="component.description">{{ component.description }}</span>
        <p class="lead" v-if="component.data.currentValue" v-html="component.data.currentValue"></p>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
// https://br.vuejs.org/v2/guide/mixins.html
import component from '@/mixins/component'

export default {
  mixins: [component],
  props: ['component'],
  name: 'component-help-block',
  data () {
    return {
      isFocus: false,
      isValue: false,
      isErrors: false
    }
  },
  created () {
    this.setValue()
  },
  mounted () {
    this.$bindEvent(document, 'click', this.interceptClickEvent)
  },
  methods: {
    interceptClickEvent: function (e) {
      var href
      var target = e.target || e.srcElement
      if (target.tagName === 'A') {
        href = target.getAttribute('href')

        // tell the browser not to respond to the link click
        e.preventDefault()

        window.open(href, '_blank')
      }
    }
  }
}
</script>
